module.exports = __webpack_public_path__ + "img/17.21578502.gif";